/**
 * 微信分享方法
 * 
 */
import axios from 'axios'
var wx = window.wx

function wechatShare() {
  axios.post('https://game.elloworld.cn/wxapi/index/getSignPackage').then((json) => {
    // console.log(json)
    var res = json.data.data
    wx.config({
      debug: false,
      appId: res.appId,
      timestamp: res.timestamp,
      nonceStr: res.nonceStr,
      signature: res.signature,
      jsApiList: ['openWXSearchPage', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'hideOptionMenu']

    });
    wx.error(function (res) {
      console.log(res)
    });
  });

  let from = GetUri('from')
  let tar = 'tt'
  if (from) {
    tar = from
  }

  var data = {
    title: "请查收你的青春考卷",
    desc: "又是一年高考季，200万签约金邀你重写高考作文题！",
    link: 'https://idea.elloworld.cn/zuowen?from=' + tar,
    imgUrl: 'https://idea.elloworld.cn/zuowen/imgs/share.jpg'
  }
  // console.log(data);

  wx.ready(function () {
    wx.checkJsApi({
      jsApiList: ['openWXSearchPage', 'getNetworkType', 'previewImage'],
      success: function (res) {
        // console.log(JSON.stringify(res));
      }
    });

    wx.onMenuShareTimeline({
      title: data.title,
      link: data.link,
      imgUrl: data.imgUrl,
      success: function (res) {
        console.log("已分享");
      },
      cancel: function (res) {
        console.log("已取消")
      }
    });

    wx.onMenuShareAppMessage({
      title: data.title,
      desc: data.desc,
      link: data.link,
      imgUrl: data.imgUrl,
      trigger: function (res) {
        console.log('用户点击发送给朋友');
      },
      success: function (res) {
        console.log('已分享');
      },
      cancel: function (res) {
        console.log('已取消');
      },
      fail: function (res) {
        console.log(JSON.stringify(res));
      }
    });
  })


}
function GetUri(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

export default wechatShare;
